import DeleteDisclaimer from './DeleteDisclaimer';
import { DISCLAIMERS } from './constants';

export default DeleteDisclaimer;
export { DISCLAIMERS };
